<mat-card class="mat-elevation-z0 under-space">
  <ng-container *ngIf="board.boardParts.length > 1">
    <div class="d-flex justify-content-between">
      <div class="form-sub-title">Bord #{{ index + 1 }}</div>
      <div (click)="delete.emit()" class="close">
        <mat-icon svgIcon="close"></mat-icon>
      </div>
    </div>
  </ng-container>

  <mat-form-field class="wide" appearance="outline">
    <textarea
      [ngClass]="client ? 'client-textarea' : ''"
      class="textarea"
      matInput
      placeholder="Omschrijf het project"
      [(ngModel)]="boardPart.layoutDescription"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="update.emit()"
      cdkTextareaAutosize
    ></textarea>
  </mat-form-field>

  <form class="form d-flex justify-content-between">
    <div class="flexer">
      <div class="form-title">
        <div class="form-title-text">Afmetingen</div>
      </div>
      <div class="upper-space">
        <mat-radio-button
          name="defaultDimensionsPicker"
          [checked]="defaultDimensions"
          (change)="defaultDimensionsChanged(true)"
        >
          <span class="strong">Standaard afmetingen:</span> in cm - H x B
        </mat-radio-button>
        <div *ngIf="defaultDimensions" class="upper-space">
          <height-and-width-selector
            [rows]="heightAndWidthOptions"
            [heightAndWidthAware]="boardPart"
            [index]="index"
            [unselect]="unselectMeasurements"
            (answer)="setHeightAndWidth($event)"
          ></height-and-width-selector>
        </div>
      </div>
      <mat-radio-button
        name="defaultDimensionsPicker"
        class="upper-space"
        [checked]="defaultDimensions === false"
        [ngClass]="defaultDimensions ? 'bottom-space' : ''"
        (change)="defaultDimensionsChanged(false)"
      >
        <span class="strong">Andere afmetingen:</span>
      </mat-radio-button>
      <div *ngIf="defaultDimensions === false" class="d-flex upper-space">
        <div class="first-form-field">
          <number-input
            [subtitle]="'Hoogte (in cm)'"
            [initValue]="alternativeHeight"
            [placeholder]="'Hoogte in cm'"
            (answer)="heightChange($event)"
          ></number-input>
        </div>

        <div class="form-field">
          <number-input
            [subtitle]="'Breedte (in cm)'"
            [initValue]="alternativeWidth"
            [placeholder]="'Breedte in cm'"
            (answer)="widthChange($event)"
          ></number-input>
        </div>
      </div>
    </div>
  </form>

  <div class="form-title">
    <div class="form-title-text">Configuratie</div>
  </div>

  <selector
    [title]="'Type bord'"
    [options]="boardTypeOptions"
    [answer]="boardPart.boardType"
    [optionValueGetter]="ordinalEnumGetter"
    [compareWith]="compareOrdinalEnum"
    (answerChange)="setBoardType($event)"
  ></selector>

  <div class="d-flex">
    <selector
      [title]="'Type plaatsing'"
      [options]="placementTypeOptions"
      [answer]="boardPart.placementType"
      [optionValueGetter]="ordinalEnumGetter"
      [compareWith]="compareOrdinalEnum"
      (answerChange)="setPlacementType($event)"
    ></selector>
    <div
      *ngIf="boardPart.placementType?.ordinal === 4"
      class="form-field free-mat-form-field full-width"
    >
      <mat-form-field appearance="outline" class="full-width">
        <input
          placeholder="Vul hier de type plaatsing in"
          matInput
          [(ngModel)]="boardPart.otherPlacementType"
          (ngModelChange)="otherPlacementTypeChange()"
          [ngModelOptions]="{ standalone: true }"
          required
        />
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="showDistanceToBottomOption" class="d-flex">
    <div>
      <div class="subtitle">Afstand tot onderkant bord</div>
      <mat-form-field appearance="outline">
        <mat-select
          matInput
          placeholder="Maak een keuze"
          [(ngModel)]="selectedDistanceToBottomOption"
          [compareWith]="compareDistanceToBottomOptions"
          required
          (ngModelChange)="setSelectedDistanceToBottomOption($event)"
        >
          <mat-option
            *ngFor="let option of distanceToBottomOptions"
            [value]="option"
          >
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div *ngIf="boardPart.distanceToBottom == null" class="flexer left-space">
      <textarea-input
        [title]="'Aangepaste afstand onderkant bord'"
        [placeholder]="
          'Beschrijf hier de aangepaste afstand tot onderkant bord'
        "
        [initContent]="boardPart.distanceToBottomText"
        [client]="client"
        (answer)="distanceToBottomTextChange($event)"
      ></textarea-input>
    </div>
  </div>

  <div class="d-flex">
    <div>
      <div class="subtitle">Geschilderde constructie</div>
      <yes-no
        [neverShowExtraInstructions]="true"
        [value]="boardPart.paintedPosts"
        (answer)="paintedPostsChange($event)"
      ></yes-no>
    </div>
    <div *ngIf="boardPart.paintedPosts" class="left-space">
      <div class="subtitle">Kleur</div>
      <div class="less-upper-space">
        <selector
          [options]="paintedPostsColorOptions"
          [answer]="boardPart.paintedPostsValue"
          [optionValueGetter]="ordinalEnumGetter"
          [compareWith]="compareOrdinalEnum"
          (answerChange)="paintedPostsValueChange($event)"
        ></selector>
      </div>
    </div>
    <div
      *ngIf="
        boardPart.paintedPosts &&
        boardPart.paintedPostsValue?.ordinal === INT_MAX_SIGNED_32_BIT_VALUE
      "
      class="form-field"
    >
      <div class="subtitle">Aangepaste kleur</div>
      <div class="less-upper-space">
        <mat-form-field class="full-width" appearance="outline">
          <input
            placeholder="Vul hier de aangepaste kleur in"
            matInput
            [(ngModel)]="boardPart.paintedPostsText"
            (ngModelChange)="paintedPostsTextChange()"
            [ngModelOptions]="{ standalone: true }"
            required
          />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="d-flex">
    <div class="first-form-field">
      <div class="subtitle">Materiaal (paneel)</div>
      <mat-form-field appearance="outline">
        <mat-select
          name="materialType"
          matInput
          placeholder="Maak een keuze"
          [(ngModel)]="boardPart.material"
          [compareWith]="compareMaterial"
          (ngModelChange)="materialUpdate($event)"
          required
        >
          <mat-option *ngFor="let option of materialOptions" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div
      *ngIf="boardPart.material?.ordinal === 16"
      class="left-space full-width"
    >
      <div class="subtitle">Beschrijving materiaal</div>
      <textarea-input
        [placeholder]="'Geef hier een beschrijving van het gewenste materiaal'"
        [initContent]="boardPart.otherMaterial"
        [minHeight]="'19px'"
        (answer)="otherMaterialChange($event)"
      ></textarea-input>
    </div>
  </div>
</mat-card>
